export class TextAnimation {
  static readonly DEFAULT_PERIOD = 120;

  animationList: string[];
  el: HTMLElement;
  loopNum = 0;
  period: number;
  txt = '';
  isDeleting = false;
  start;
  txtEnd;

  constructor(el: HTMLElement, animationList: string[], period = TextAnimation.DEFAULT_PERIOD) {
    this.animationList = animationList;
    this.el = el;
    this.loopNum = 0;
    this.period = period;
    this.txt = '';
    this.isDeleting = false;
  }

  private _tick(timeStamp) {
    const delta = this.txtEnd ? this.period * 10 : this.period;
    if(!this.start) {
      this.start = timeStamp;
    } else {
      const diff = timeStamp - this.start;

      if(diff < delta) {
        window.requestAnimationFrame((timeStamp) => this._tick(timeStamp));
        return;
      } else {
        this.start = timeStamp;
        this.txtEnd = false;
      }
    }

    const i = this.loopNum % this.animationList.length;
    const fullTxt = this.animationList[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.textContent = this.txt;

    if (!this.isDeleting && this.txt === fullTxt) {
      this.isDeleting = true;
      this.txtEnd = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
    }

    window.requestAnimationFrame((timeStamp) => this._tick(timeStamp));

  }

  run() {
    window.requestAnimationFrame((timeStamp) => this._tick(timeStamp));
  }
}
